import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpClientHelper } from 'src/app/cores/httpClientHelper';
import { BaseService } from './base.service';

@Injectable({providedIn: 'root'})
export class CommonService extends BaseService {
    constructor(private httpClient: HttpClient) {
        super()
     }

    GetOccupationsForComboBox(){
        return this.httpClient.get<any[]>(HttpClientHelper.baseURL+"common/GetOccupationsForComboBox");
    }

   GetMoneyTransferComboBoxes(){
       return this.httpClient.get<any[]>(HttpClientHelper.baseURL+"common/GetMoneyTransferComboBoxes");
   }

   GetBranchesForComboBox(){
       return this.httpClient.get<any[]>(HttpClientHelper.baseURL+"common/GetBranchesForComboBox");
   }

   Getofficesforcomobox() {
       return this.httpClient.get<any[]>(HttpClientHelper.baseURL+"offices/getofficesforcombobox");
   }

   Getcashesforcombobox() {
        return this.httpClient.get<any[]>(HttpClientHelper.baseURL+"settings/getcashesforcombobox");
   }

   GetCurrenciesforcombobox() {
        return this.httpClient.get<any[]>(HttpClientHelper.baseURL+"common/GetCurrenciesForComboBox");
    }

    SearchCustomersByNameForComboBox(name:string) {
        return this.httpClient.get<any[]>(HttpClientHelper.baseURL+`common/SearchCustomersByNameForComboBox?customerName=${name}`)
    }
    SearchCustomersByAnyForComboBox(name:string) {
        return this.httpClient.get<any[]>(HttpClientHelper.baseURL+`common/SearchCustomersByAnyForComboBox?any=${name}`)
    }

    SearchCustomersByCustomerIdAndTell(any:string) {
      if(any.length <= 5) {
         return this.httpClient.get<any[]>(HttpClientHelper.baseURL+`common/SearchCustomersByCustomerId?any=${any}`)
      }else {
         return this.httpClient.get<any[]>(HttpClientHelper.baseURL+`common/SearchCustomersByTell?any=${any}`)
      }
    }





    GetCustomerByIdForComboBox(id:number){
        return this.httpClient.get<any>(HttpClientHelper.baseURL+`common/GetCustomerByIdForComboBox?customerId=${id}`)
    }

    GetCustomerRemains(id:number){
        return this.httpClient.get<any[]>(HttpClientHelper.baseURL+`common/GetCustomerRemains?customerId=${id}`)
    }

    GetBankNamesForComboBox(){
        return this.httpClient.get<any[]>(HttpClientHelper.baseURL+"journal/GetBankNamesForComboBox")
    }

    GetDate() {
        return this.httpClient.get(HttpClientHelper.baseURL+"common/GetDate",{responseType: 'text'});
    }


    getCountriesForComboBox(){
         return this.httpClient.get<any[]>(HttpClientHelper.baseURL+"common/GetCountriesForComboBox");
    }

    GetBusienessStructrues() {
        return this.httpClient.get<any[]>(HttpClientHelper.baseURL + `Customers/Structures`)
    }


    TopDebtorList() {
        return this.httpClient.get<any[]>(HttpClientHelper.baseURL+ `common/TopDebtorList`);
    }

    CashReportList() {
        return this.httpClient.get<any[]>(HttpClientHelper.baseURL+ `common/CashReportList`);
    }

    BankReportList() {
        return this.httpClient.get<any[]>(HttpClientHelper.baseURL+ `common/BankReportList`);
    }

    LastReceivedMoneyTransfer() {
        return this.httpClient.get<any[]>(HttpClientHelper.baseURL+ `common/LastReceivedMoneyTransfer`);
    }

    LastSentMoneyTransfer() {
        return this.httpClient.get<any[]>(HttpClientHelper.baseURL+ `common/LastSentMoneyTransfer`);
    }

    SpecialCustomers() {
        return this.httpClient.get<any[]>(HttpClientHelper.baseURL + `common/SpecialCustomers`);
    }

    GetNotes() {
        return this.httpClient.get<any[]>(HttpClientHelper.baseURL+`common/GetNotes`);
    }

    UnperformedMoneyTransfers() {
        return this.httpClient.get<any[]>(HttpClientHelper.baseURL+'common/UnperformedMoneyTransfers');
    }



}
